import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorReturnHeaderSearch = () => {
  const returnHeaderSearch = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/transaction-retur-header/search', payload, (response) => {
      if (response.status_code === 200) {
        if (response.data) {
          callback(response.data)
        } else {
          callback(null)
        }
      }
      loading(false)
    })
  }, [])

  return { returnHeaderSearch }
}

export default InteractorReturnHeaderSearch
